module.exports = __webpack_public_path__ + "img/BomberosLogo.2c49a476.svg";